import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIncomingCallIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="M10.367 6a.7.7 0 0 0 .26.046h2.666a.667.667 0 1 0 0-1.333h-1.06l2.194-2.193a.666.666 0 1 0-.94-.94l-2.194 2.186v-1.06a.667.667 0 0 0-1.333 0v2.667q0 .134.047.26a.67.67 0 0 0 .36.367m2.593 2.666c-.147 0-.3-.046-.447-.08a6 6 0 0 1-.873-.26 1.333 1.333 0 0 0-1.653.667l-.147.3A8.1 8.1 0 0 1 8.067 7.96a8.1 8.1 0 0 1-1.334-1.774L7.013 6a1.333 1.333 0 0 0 .667-1.654 7 7 0 0 1-.26-.873q-.05-.222-.08-.453a2 2 0 0 0-2-1.66h-2a2 2 0 0 0-2 2.273 12.666 12.666 0 0 0 11.013 10.973h.254a2 2 0 0 0 1.827-1.185 2 2 0 0 0 .173-.821v-2a2 2 0 0 0-1.647-1.934m.333 4a.666.666 0 0 1-.482.641.7.7 0 0 1-.291.026A11.33 11.33 0 0 1 2.713 3.48a.73.73 0 0 1 .167-.547.67.67 0 0 1 .5-.227h2a.67.67 0 0 1 .667.527q.04.273.1.54.116.528.306 1.033l-.933.434a.667.667 0 0 0-.327.886 9.66 9.66 0 0 0 4.667 4.667.67.67 0 0 0 .507 0 .67.67 0 0 0 .38-.347l.413-.933q.518.185 1.053.307.267.06.54.1a.67.67 0 0 1 .527.666z"
    />
  </svg>
);
export default SvgIncomingCallIcon;
